import React, { useState } from "react";
import "./fileOption.css";
import { PDFExport } from "@progress/kendo-react-pdf";
import { handlePreview } from "./adminFunction";
import { useDispatch, useSelector } from "react-redux";
import { updateQuantityInfo } from "../../../Features/quantityInfo";
import BOQ from "../summaryBOQ/boq";
import PDF from "../summaryReport/pdf";
import { Button, Modal } from "react-bootstrap";
import FeaturePreview from "../Summary/featurePreview";

export default function FilesOption() {
  const dispatch = useDispatch();
  const quantityInfo = useSelector((state) => state.quantity);
  const roofInfo = useSelector((state) => state.roof);
  const roofData = quantityInfo?.roofData || [];
  const roofIndex = quantityInfo.roofNo;
  //   const roofDetail = roofData[roofIndex];

  const [boq, setBoq] = useState(false);
  const [report, setReport] = useState(false);
  const [showFeatureSelection, setShowFeatureSelection] = useState(false);
  const [disclaimerEmpty, setDisclaimerEmpty] = useState(false);
  const pdfExportComponent = React.useRef(null);
  const [userInfo, setUserInfo] = useState({
    companyName: "",
    companyLogo: "",
    reportInfo: "",
  });

  const exportPDFWithComponent = () => {
    if (pdfExportComponent.current) {
      pdfExportComponent.current.save();
    }
  };
  const handleClose = () => {
    setBoq(false);
  };
  const handleReportClose = () => setReport(false);

  return (
    <>
      <div className="fileOption">
        <div className="formWithLabel">
          <h1>Select Roof</h1>
          <div className="roofContainer">
            {roofData.length > 1 && (
              <div
                className={
                  quantityInfo.allRoof === true
                    ? "roofBox roofActive"
                    : "roofBox roofBoxD"
                }
              >
                <img src={"../images/icons/roof.png"} alt={"roof"} />
                <h2>All Roof</h2>
                {quantityInfo.allRoof === false && (
                  <div
                    className="disable"
                    onClick={() =>
                      dispatch(updateQuantityInfo({ allRoof: true }))
                    }
                  ></div>
                )}
              </div>
            )}
            {roofData.map((item, i) => (
              <div
                key={i}
                className={
                  roofIndex === i && quantityInfo.allRoof === false
                    ? "roofBox roofActive"
                    : "roofBox roofBoxD"
                }
              >
                <img src={"../images/icons/roof.png"} alt={"roof"} />
                <h2>Roof{i + 1}</h2>
                {(i !== quantityInfo.roofNo ||
                  quantityInfo.allRoof === true) && (
                  <div
                    className="disable"
                    onClick={() =>
                      dispatch(
                        updateQuantityInfo({ roofNo: i, allRoof: false })
                      )
                    }
                  ></div>
                )}
              </div>
            ))}
          </div>
        </div>
        <div className="formWithLabel">
          <h1>Preview Files</h1>
          <div className="viewButton">
            <button className="viewReport" onClick={() => setBoq(true)}>
              View BOQ
            </button>
            {roofInfo.value.inverterAnalysis && (
              <button
                className="viewReport"
                onClick={() => setShowFeatureSelection(true)}
              >
                View Detail Report
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Modal FOR VIEW BOQ */}
      <Modal
        className="modalBOQ"
        show={boq}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        style={{ width: "100%" }}
      >
        <Modal.Body>
          <div className="border rounded p-2">
            <PDFExport
              ref={pdfExportComponent}
              paperSize="A4"
              margin={2}
              fileName={`${
                roofInfo.value.siteName
              }BOQ${new Date().getFullYear()}`}
            >
              <BOQ></BOQ>
            </PDFExport>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={exportPDFWithComponent}>
            Download BOQ
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal FOR VIEW REPORT Feature OPTION */}
      <Modal
        show={showFeatureSelection}
        onHide={() => setShowFeatureSelection(false)}
        backdrop="static"
        keyboard={false}
        centered
        className="featureModal"
      >
        <Modal.Body className="feature-show-model">
          <FeaturePreview
            setShowFeatureSelection={setShowFeatureSelection}
            disclaimerEmpty={disclaimerEmpty}
            userInfo={userInfo}
            setUserInfo={setUserInfo}
          ></FeaturePreview>
          <div className="button-pair">
            <button
              className="closeButton"
              onClick={() => setShowFeatureSelection(false)}
            >
              Close
            </button>
            <button
              className="nextButton"
              onClick={() => {
                handlePreview({
                  userInfo,
                  setDisclaimerEmpty,
                  setShowFeatureSelection,
                  setReport,
                });
              }}
            >
              Preview Report
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Modal FOR VIEW REPORT */}
      <Modal
        className="modalBOQ modalReport"
        show={report}
        onHide={handleReportClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="border rounded">
            <PDFExport
              ref={pdfExportComponent}
              paperSize="A4"
              fileName={`${
                roofInfo.value.siteName
              }REPORT${new Date().getFullYear()}`}
            >
              <PDF userInfo={userInfo}></PDF>
            </PDFExport>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleReportClose}>
            Close
          </Button>
          <Button variant="primary" onClick={exportPDFWithComponent}>
            Download Report
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
